import styled, { createGlobalStyle, css } from 'styled-components'
import { Container, Row } from 'reactstrap'

export const Global = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    width: 100%;
    height: 100%;
    min-height: 100%;
    min-width: 200px;
    overflow-x: hidden;
    background: #ffffff;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.33;
    font-family: "Nunito Sans", sans-serif;
  }

  ul,
  li,
  a,
  p,
  body,
  strong,
  div {
    margin: 0px;
    padding: 0px;
    font-family: 'Nunito Sans', sans-serif;
  }

  p {
    margin-bottom: 1rem;
  }


  main {
    overflow: hidden;
    max-width: 100%;
  }
  @media (max-width: 992px) {
    .slick-list{
      padding: 0!important;
    }
  }
  .slick-prev, .slick-next{
    z-index: 20;
  }
  .slick-prev:before, .slick-next:before{
    display: block;
  }
  .ot-form-wrapper {
    max-width: 750px;
    height: 800px;
    border: 1px solid #c0c2c7;
    margin: auto;
  }
  .ot-form-wrapper iframe {
      width: 100%;
      height: 100%;
      border: none;
  }
`
export const sizes = {
  xs: '12px',
  sm: '0.875rem',
  base: '1rem',
  lg: '2.75rem',
  xl: '3.5rem',
  xxl: '4.75rem',
  xxxl: '5.5rem',
  xxxxl: '6rem'
}

const HeadingStyle = css`
  margin-top: 0;
  margin-bottom: ${props => props.marginBottom || '16px'};
  font-weight: ${props => props.weight || '700'};
  font-family: 'Source Serif Pro', sans-serif;
  text-align: ${props => props.textAlign || 'center'};
`

export const H1 = styled.h1`
  ${HeadingStyle};
  color: ${p => p.color || p.theme.colors.white};
  line-height: 1;
  @media (min-width: 768px) {
    font-size: 80px;
  }
`

export const H2 = styled.h2`
  ${HeadingStyle};
  font-size: 40px;
  color: ${p => p.color || p.theme.colors.white};
  line-height: 1;
  margin-bottom: 50px;
  @media (min-width: 768px) {
    font-size: 60px;
  }
  @media (min-width: 1024px) {
    margin-bottom: 100px;
  }
`

export const H3 = styled.h3`
  ${HeadingStyle};
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0;
  color: ${p => p.color || p.theme.colors.navy};
  @media (min-width: 768px) {
    font-size: 30px;
    line-height: 38px;
    text-align: left;
  }
`

export const ContainerLg = styled(Container)`
  @media (min-width: 1270px) {
    max-width: 1270px !important;
  }
`

export const Section = styled.div`
  width: 100%;
  padding: 60px 0;
  background-color: ${p => p.bgColor || p.theme.colors.white};
  @media screen and (min-width: 1025px) {
    padding: ${props => props.size || '100px 0'};
  }
`

export const Heading = styled.h3`
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
  color: ${p => p.color || p.theme.colors.gold};
  margin-bottom: 15px;
  font-family: 'Source Serif Pro', sans-serif;
  @media screen and (min-width: 1025px) {
    font-size: 56px;
    margin-bottom: 13px;
  }
`

export const Paragraph = styled.p`
  font-size: 14px;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  margin-bottom: ${props => props.marginBottom || '16px'};
  color: ${p => p.color || p.theme.colors.blueGray};
  @media (min-width: 768px) {
    font-size: 16px;
  }
`

export const Placeholder = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${p => p.theme.colors.lightBlue};
`

export const Lead = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: ${p => p.color || p.theme.colors.white};
  @media screen and (min-width: 768px) {
    font-size: 20px;
    line-height: 27px;
  }
`

export const RowCentered = styled(Row)`
  justify-content: center;
`
export const Hr = styled.hr`
  margin: 0;
`
